import { Link } from "react-router-dom";
import { Box, CircularProgress, Modal, Typography } from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import TextFieldComponent from "components/input/TextFieldComponent";
import { MESSAGE } from "constants/validate";
import Header from "../../../components/Header";
import useLogin from "../hooks/useLogin";

/**
 *
 */
function Login() {
  const {
    email,
    password,
    errorMessage,
    disableSubmit,
    setEmail,
    setErrors,
    setPassword,
    handleSubmit,
  } = useLogin();

  return (
    <>
      <Header showMenu={false} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 50px)",
          bgcolor: "background.paper",
          p: 3,
        }}
      >
        <img src="/img/login/yhbb_login_top.png" alt="YHBB Login" />
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 6,
            width: "100%",
            maxWidth: "760px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "32px",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <TextFieldComponent
              title="メールアドレス"
              value={email}
              onChangeText={setEmail}
              type="text"
              sxBox={{ width: "500px", justifyContent: "flex-end" }}
              sx={{ width: "240px" }}
              onError={(error) => {
                setErrors((pre) => ({ ...pre, email: error }));
              }}
              validateOption={{
                required: {
                  message: MESSAGE.EMPTY_EMAIL,
                },
                email: {
                  message: MESSAGE.INVALID_EMAIL,
                },
              }}
            />

            <TextFieldComponent
              title="パスワード"
              value={password}
              onChangeText={setPassword}
              sxBox={{ width: "500px", justifyContent: "flex-end" }}
              sx={{ width: "240px" }}
              type="password"
              onError={(error) => {
                setErrors((pre) => ({ ...pre, password: error }));
              }}
              validateOption={{
                required: {
                  message: MESSAGE.EMPTY_PASSWORD,
                },
                minLength: {
                  value: 8,
                  message: MESSAGE.VALIDATION_PASSWORD(8),
                },
                // includeNumber: {
                //   message: MESSAGE.VALIDATION_PASSWORD(8),
                // },
                // includeAlphabet: {
                //   message: MESSAGE.VALIDATION_PASSWORD(8),
                // },
                halfWidth: {
                  message: MESSAGE.VALIDATION_PASSWORD(8),
                },
              }}
            />
          </Box>
          {errorMessage && (
            <Box sx={{ display: "flex", width: 500, justifyContent: "flex-end", marginTop: "16px" }}>
              <Typography
                sx={{
                  width: 240,
                  color: "var(--error)",
                  fontSize: 14,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {errorMessage}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: "flex", width: 500, justifyContent: "flex-end" }}>
            <ButtonComponent
              disabled={disableSubmit}
              type="submit"
              label="ログイン"
              theme="dark"
              sx={{ marginTop: "38px", width: "240px" }}
            />
          </Box>
        </Box>
        <Typography
          sx={{
            paddingTop: "75px",
            textDecoration: "underline",
            fontWeight: "fontWeightRegular",
            fontSize: { xs: 16, md: 18, lg: 20 },
          }}
        >
          <Link to="/forgot-password" style={{ textDecoration: "none", color: "var(--black)" }}>
            パスワードを忘れた方はこちら
          </Link>
        </Typography>
        <Typography
          sx={{
            textDecoration: "underline",
            position: "absolute",
            bottom: "40px",
            color: "textSecondary",
          }}
        >
          <Link to="/changelog" style={{ textDecoration: "none", color: "var(--black)" }}>
            Ver.0.00
          </Link>
        </Typography>
      </Box>
    </>
  );
}

export default Login;
